var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkipForwardWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ED2619AC-0AB9-424D-913A-B10BC671CE84") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sprite-Sheet-skip-forward",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web-Icon-Sheet-1.5v-skip-forward",
    transform: "translate(-592.000000, -352.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "white-skipForward-skip-forward",
    transform: "translate(580.000000, 340.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-skip-forward",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "Forward-skip-forward",
    transform: "translate(12.000000, 12.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,1.00087166 C14,0.448105505 14.4426603,0 14.9989566,0 L16.0010434,0 C16.5527519,0 17,0.444630861 17,1.00087166 L17,14.9991283 C17,15.5518945 16.5573397,16 16.0010434,16 L14.9989566,16 C14.4472481,16 14,15.5553691 14,14.9991283 L14,1.00087166 Z M11.7298355,7.2183603 C12.431328,7.65004799 12.4246323,8.35407245 11.7298355,8.7816397 L1.2701645,15.2183603 C0.568672019,15.650048 0,15.3328702 0,14.4947588 L0,1.50524116 C0,0.673919421 0.575367734,0.354072452 1.2701645,0.781639695 L11.7298355,7.2183603 Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipForwardWhite);
export default __webpack_public_path__ + "static/media/skip-forward-white.3d7abf1b.svg";
export { ForwardRef as ReactComponent };